import angular from 'angular';

import { objectsNaviPanel } from './objects.navi.panel.directive';
import { ObjectsNaviPanel } from './objects.navi.panel.resource';

export default angular
  .module('objects.navi.panel', [])
  .directive('objectsNaviPanel', objectsNaviPanel)
  .factory('ObjectsNaviPanel', ObjectsNaviPanel);
